<angular-multiselect [data]="itemList" [(ngModel)]="selectedItems" [settings]="settings" (onSelect)="onItemSelect($event)"
(onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)" 
(onGroupSelect)="onGroupSelect($event)" (onGroupDeSelect)="onGroupDeSelect($event)">
<c-badge>
    <ng-template let-item="item">
        <label style="margin: 0px;">{{item.itemName}}</label>
        <img [src]="item.image" style="width: 16px; margin: 0 0 0 4px;" />
    </ng-template>
</c-badge>
<c-item>
    <ng-template let-item="item">
        <img [src]="item.image" style="width: 30px; border: 1px solid #efefef;margin-right: 20px;" />
        <label style="color: #333;margin-right: 20px;">{{item.itemName}}</label>
        <label><small>Capital - {{item.capital}}</small></label>
    </ng-template>
</c-item>
</angular-multiselect>